import React from 'react';
import _ from 'underscore';
import {
  processImageSizeLimitError,
  processVideoSizeLimitError,
} from './upload-asset-limit-error';
import { fetchResultFromProcessors } from './processor-util';

const errorCodeMessageKeyMapping = {
  InvalidDuration: _TL_('One or more videos failed to upload because their duration is outside the valid range: 6 - 120 seconds.'),
  AssetDataInvalidWidth: _TL_('One or more videos failed to upload because their width is outside the valid range: 120 - 4096 pixels'),
  AssetDataInvalidHeight: _TL_('One or more videos failed to upload because their height is outside the valid range: 120 - 2160 pixels'),
  ImageAIUpScaleFailed: _TL_('One or more images are smaller than the required minimum size (703 x 368).'),
};

const processAssetLimitErrors = ({
  codes, aid, logger, i18n,
}) => {
  const imageSizeLimitResult = processImageSizeLimitError({ errorList: codes, aid, logger });

  if (imageSizeLimitResult) {
    const { limit: imageAssetLimit } = imageSizeLimitResult;

    return i18n.getString(
      _TL_('One or more images failed to upload because your account has exceeded the {{value}}-image asset limit. Please remove assets and try again.'),
      { value: imageAssetLimit }
    );
  }

  const videoSizeLimitResult = processVideoSizeLimitError({ errorList: codes, aid, logger });
  if (videoSizeLimitResult) {
    const { limit: videoAssetLimit } = videoSizeLimitResult;

    return i18n.getString(
      _TL_('One or more videos failed to upload because your account has exceeded the {{value}}-video asset limit. Please remove assets and try again.'),
      { value: videoAssetLimit }
    );
  }

  return '';
};

const processImageErrors = ({ codes, filePickerI18n }) => filePickerI18n.getString(`ImageExperience_Error_${codes[0]}`);

const processPredefinedAssetErrors = ({ codes, i18n }) => {
  const mappedKey = errorCodeMessageKeyMapping[codes[0]];

  return mappedKey ? i18n.getString(mappedKey) : '';
};

export const getAssetUploadError = ({
  uploadErrorCodeArr,
  i18n,
  filePickerI18n,
  aid,
  logger,
  disableGenericMessage = false,
} = {}) => {
  if (_.size(uploadErrorCodeArr) > 0) {
    const errorMessage = fetchResultFromProcessors({
      processors: [
        processAssetLimitErrors,
        processImageErrors,
        processPredefinedAssetErrors,
      ],
      options: {
        codes: uploadErrorCodeArr,
        filePickerI18n,
        i18n,
        aid,
        logger,
      },
    });

    if (disableGenericMessage || errorMessage) {
      return errorMessage;
    }

    const genericMessage = (
      <span>
        {
          i18n.getString(_TL_('One or more assets failed to upload. Please try again'))
        }
        <a style={{ marginLeft: 5 }} className="HelpTopic" href=" " query="help:app54863" role="button">{i18n.getString(_TL_('Learn more about asset guidelines and accepted file types.'))}</a>
      </span>
    );

    return genericMessage;
  }

  return '';
};
